import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import React from "react";

interface ISuccessResetDialogProps {
  open: boolean;
  onClose: (e: any) => void;
}

const SuccessResetDialog: React.FC<ISuccessResetDialogProps> = (props) => {
  return (
    <Dialog open={props.open} onClose={props.onClose} fullScreen>
      <DialogTitle>
        <Typography variant={"body1"} align="center">
          Sikeres küldés!
        </Typography>
      </DialogTitle>
      <DialogContent style={{ textAlign: "center" }}>
        <Typography variant={"body1"}>
          Kiküldtük a jelszó visszaállító hivatkozást az email címre, nézd meg
          az email fiókod a továbbiakhoz.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant={"contained"}
          color={"primary"}
          fullWidth
          onClick={props.onClose}
        >
          Bejelentkezés
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessResetDialog;
